import React, { useState, useEffect } from 'react';
import { store } from '../../app/store';
import { postAPI } from '../../app/api';
// import Sidebar from '../Universal/Sidebar';
// import Header from '../Universal/Header';

export default function Results() {
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const store_data = JSON.parse(store());
  const [ResultData, setResultData] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchResultData = async () => {
    const filter = { org_id: store_data?.org_id, user_id: store_data?.user_id }
    const response = await postAPI("/results/complete-list", filter);
    if (response?.status) {
      setResultData(response?.data)
      setLoading(false)
    } else {
      setResultData([])
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchResultData();
  }, [])
  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
              Back
            </button>
            <p className='text-right mb-0'><small className="fw-bold py-3">Dashboard<span className="text-muted fw-light"> / Results</span> </small></p>
          </div>
          <div class="container-xxl flex-grow-1 container-p-y">
            <div class="row">
              {
                ResultData && ResultData.length > 0 ?
                  ResultData?.map((val, index) => (
                    <div class="col-md-6 col-xl-4 order-2 order-lg-1">
                      <div class="card" style={{ paddingBottom: "32px" }}>
                        <div class="card-body text-center">
                          <h5>{val?.exam_title}</h5>
                          <p className='mt-1'>Exam Date: {val?.date}</p>
                          <p className='mt-1'>Exam Portal Open Time : {val?.start_time}</p>
                          <p className='mt-1'>Exam Portal Close Time : {val?.end_time}</p>
                        </div>
                        <div class="card-footer text-center">
                          <button class="btn btn-primary waves-effect waves-light" type="button" onClick={() => {window.location.href = `/Results/${val?.id}`}}>Check Results</button>
                        </div>
                      </div>
                    </div>
                  ))
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
